import { useTranslation } from "react-i18next";
import backgroundImg from "../img/for_whom.svg";
import styles from "../css/heatmaps/ForWhom.module.css";
import BoxesFroSmall from "./BoxesFroSmall";
import meterIcon from "../img/banner/meter.svg";
import shieldIcon from "../img/banner/shield.svg";
import basketicon from "../img/banner/basket.svg";
import Pack from "./Pack";

const icons = [meterIcon, shieldIcon, basketicon];

const ForWhomHM = () => {
  const { t } = useTranslation();

  const content = t("heatmaps.forWhom", { returnObjects: true });

  return (
    <Pack dataComponent={"for-whom-heatmaps"}>
      <h2 className="title">{content.heading}</h2>
      <div className={styles.container}>
        <img src={backgroundImg} />
        <div className={styles.content}>
          {content.texts.map((text, index) => (
            <div key={index} className={styles.contentItem}>
              <h4>{text.title}</h4>
              <p>{text.text}</p>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.containerSmall}>
        <BoxesFroSmall
          content={content}
          objectContent={true}
          bgColor="green"
          icons={icons}
        />
      </div>
    </Pack>
  );
};

export default ForWhomHM;
